import ApiClient from './apiClient'
import {
  CsvList,
  CsvExportParams,
  DataSheetList,
  DataSheetExportParams,
} from '../types/export'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCsvExportList = async (): Promise<any> => ApiClient.get(
  '/api/export/csv',
  (result: CsvList) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postCsvExport = async (params: CsvExportParams): Promise<any> => ApiClient.post(
  '/api/export/csv',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCsvExportFile = async (id: string): Promise<any> => ApiClient.get(
  `/api/v1/features/export/csv/download/${id}`,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (result: any) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getDataSheetExportList = async (): Promise<any> => ApiClient.get(
  '/api/v1/features/export',
  (result: DataSheetList) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postDataSheetExport = async (params: DataSheetExportParams): Promise<any> => ApiClient.post(
  '/api/v1/features/export',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getDataSheetExportFile = async (id: string): Promise<any> => ApiClient.get(
  `/api/v1/features/export/${id}`,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (result: any) => result,
)
